module.exports = __webpack_public_path__ + "media/dashboard/assets/images/delivery_icon-aecdd929fa101637b18708f6d1a59b08.svg";